module.exports = "<spinner ng-show=\"$ctrl.loader\"></spinner><ng-transclude> </ng-transclude>";